import { render, staticRenderFns } from "./fifthfirst.vue?vue&type=template&id=2f5c2f4c&"
import script from "./fifthfirst.vue?vue&type=script&lang=js&"
export * from "./fifthfirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5c2f4c')) {
      api.createRecord('2f5c2f4c', component.options)
    } else {
      api.reload('2f5c2f4c', component.options)
    }
    module.hot.accept("./fifthfirst.vue?vue&type=template&id=2f5c2f4c&", function () {
      api.rerender('2f5c2f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/fifth/fifthfirst.vue"
export default component.exports